import React from 'react';

const SendMessage = (props) => {
    
    return (
        <li><a href={`/chat/0`}><img src="/assets/images/emal_icon.png"/></a></li>
    );
} 

export default SendMessage;